import get from "lodash/get";
import { storyFields } from "../isomorphic/constants";

// user auth functions

export const getExistingUser = async (email) => {
  const url = `/api/auth/v1/users/email/check?email=${email}`;
  try {
    const response = await fetch(url);
    const userObj = await response.json();
    return userObj;
  } catch (error) {
    console.error(error);
  }
};

export const getSearchPageItems = async (slug, offset, limit) => {
  const { results } = await (await fetch(`/api/v1/search?q=${slug}&offset=${offset}&limit=${limit + 1}`)).json();
  const loadMoreStories = results.stories.map((story) => {
    return { type: "story", story: story };
  });
  return loadMoreStories;
};

export const getStories = async (query, slug, offset, limit) => {
  const { stories } = await (
    await fetch(`/api/v1/stories?${query}=${slug}&offset=${offset}&limit=${limit + 1}`)
  ).json();
  const loadMoreStories = stories.map((story) => {
    return { type: "story", story: story };
  });
  return loadMoreStories;
};

export const getCollectionitems = async (slug, offset, limit, fields) => {
  let url = `/api/v1/collections/${slug}?&item-type=story&offset=${offset}&limit=${limit + 1}`;
  if (fields) {
    url = `/api/v1/collections/${slug}?&item-type=story&offset=${offset}&limit=${limit + 1}&fields=${fields}`;
  }
  try {
    const response = await fetch(url);
    const { items } = await response.json();
    return items;
  } catch (error) {
    console.error(error);
  }
};

export const getCollectionBySlug = async (slug, offset, limit, fields = "") => {
  try {
    const response = await fetch(
      `/api/v1/collections/${slug}?&item-type=story&offset=${offset}&limit=${limit + 1}&fields=${fields}`
    );
    return await response.json();
  } catch (error) {
    console.error(error);
  }
};

export const getAuthorStories = async (id, offset, limit) => {
  try {
    const { items } = await (
      await fetch(
        `/api/v1/authors/${id}/collection?&item-type=story&offset=${offset}&limit=${limit}&fields=${storyFields}`
      )
    ).json();
    return items;
  } catch (error) {
    console.error(error);
  }
};

export const getRelatedStories = async (storyId, sectionId, fields = "", limit = 4) => {
  try {
    const response = await fetch(
      `/api/v1/stories?section-id=${sectionId}&limit=${limit}&not-story-content-ids=${storyId}&fields=${fields}`
    );
    const items = await response.json();
    return items;
  } catch (error) {
    console.error(error);
  }
};
export const getLatestMagazines = async ({ magazineSlug = "fortune-magazine", limit = 5 }) => {
  try {
    const response = await fetch(
      `/api/v1/magazines/${magazineSlug}/issues?sort-by=issue-date&order=desc&limit=${limit}`
    );
    const items = await response.json();
    return items;
  } catch (error) {
    console.error(error);
  }
};

export const getMagazinesInRange = async (from, to, magazineSlug = "fortune-magazine", limit = 15) => {
  try {
    const response = await fetch(`/api/v1/magazines/${magazineSlug}/issues?from=${from}&to=${to}&limit=${limit}`);
    const items = await response.json();
    return items;
  } catch (error) {
    console.error(error);
  }
};

export const getMagazineCollectionDetails = async (collectionSlug, magazineSlug = "fortune-magazine") => {
  try {
    const response = await fetch(`/api/v1/magazines/${magazineSlug}/issues/${collectionSlug}`);
    const items = await response.json();
    return items;
  } catch (error) {
    console.error(error);
  }
};

export const getFilteredMagazineCollection = (storyId) => {
  return fetch(`/api/v1/stories/${storyId}/attributes`)
    .then((response) => response.json())
    .then((response) => {
      const filteredMagazineCollection = response?.collections?.find((collection) =>
        get(collection, ["metadata", "entities", "collectionEntities", "magazine"])
      );

      const collections = response?.collections || [];
      const matchedCollection = collections.find((collection) => {
        return (
          get(collection, ["metadata", "entities", "collectionEntities", "magazine", 0, "slug"]) === "fortune-magazine"
        );
      });
      const issueSlug = matchedCollection?.slug || "";

      const magazineSlug = get(
        filteredMagazineCollection,
        ["metadata", "entities", "collectionEntities", "magazine", 0, "slug"],
        ""
      );
      return { issueSlug, magazineSlug };
    })
    .catch((err) => console.log("error", err));
};

export const getAdvancedSearchItems = async (
  query = "",
  slug = "",
  offset = 0,
  limit = 10,
  sort = "latest-published"
) => {
  const response = await fetch(
    `/api/v1/advanced-search?${query}=${slug}&offset=${offset}&limit=${limit + 1}&sort=${sort}`
  );
  const data = await response.json();
  const advancedSearchItems =
    data?.items?.map((story) => ({
      type: "story",
      story,
    })) ?? [];

  return advancedSearchItems;
};

export const getBreakingNews = async () => {
  try {
    const timestamp = Date.now();
    const url = `/api/v1/breaking-news?_=${timestamp}`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.stories || [];
  } catch (error) {
    console.error("Error fetching breaking news:", error);
    return null;
  }
};

export async function generateJwtToken(integrationsId) {
  try {
    const response = await fetch(`/access-token/integrations/${integrationsId}`);
    if (!response.ok) {
      throw new Error(`Error fetching JWT: ${response.status}`);
    }
    const result = response.headers.get("x-integration-token");
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function validateUser(token, redirectURL) {
  try {
    const response = await fetch("/api/auth/v1/login/google-one-tap", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, "redirect-url": redirectURL }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error validating user:", error);
    throw error;
  }
}

export const fetchTrendingPeople = async (queryString = "") => {
  try {
    const url = `/trendingPeopleWidget${queryString ? `?${queryString}` : ""}`;

    const response = await fetch(url, {
      cache: "force-cache",
    });
    if (!response.ok) throw new Error("Failed to fetch trending people");
    const data = await response.json();
    return data.items || [];
  } catch (err) {
    console.error("fetchTrendingPeople error:", err);
    return [];
  }
};

export const getAuthorById = async (authorId) => {
  try {
    const response = await fetch(`/api/v1/authors/${authorId}`);
    const data = await response.json();
    return data.author || data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
